import styled from 'styled-components';
import { Alert as AlertBase } from '@mui/lab';

const Alert = styled(AlertBase)`
  max-width: fit-content;
  text-wrap: wrap;
  color: ${({ theme }) => theme.palette.common.black};

  .MuiAlert-icon {
    color: ${({ theme }) => theme.palette.common.black};
  }
  margin: 8px;
`;

export default Alert;
